import React from "react";
import BackgroundPhoto from "../Components/BackgroundPhoto";

export default function Wait_UBOs() {
  document.title = "Onboarding";
  return (
    <BackgroundPhoto>
      <h5>We have sent an email to the other significant shareholders.</h5>
      <h5>
        Once their KYC has been completed we will update you by email on next
        steps.
      </h5>
    </BackgroundPhoto>
  );
}
